import React, { useRef, useEffect } from 'react';
import { ReactLenis } from 'lenis/react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import Marquee from '../components/sections/Marquee';
import AboutSection from '../components/sections/AboutSection';
import WhatYouGetSection from '../components/sections/WhatYouGetSection';
import ApproachSection from '../components/sections/ApproachSection';
import ResultsSection from '../components/sections/ResultsSection';
import ContactSection from '../components/sections/ContactSection';

const LandingPage = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      if (lenisRef.current?.lenis) {
        window.__lenis = lenisRef.current.lenis;
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <ReactLenis ref={lenisRef} root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="min-h-screen bg-black selection:bg-white selection:text-black" data-testid="landing-page">
        <Navbar />
        <main>
          <HeroSection />
          <Marquee />
          <ResultsSection />
          <AboutSection />
          <ApproachSection />
          <WhatYouGetSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
};

export default LandingPage;
